import React, { createContext, useState } from 'react';

const UserContext = createContext({
  name: '',
  phone: '',
  alertCancelled: false,
  setName: (setName) => {},
  setPhone: (setPhone) => {},
  setAlertCancelled: (v) => {}
});

export function UserContextProvider(props) {

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [alertCancelled, setAlertCancelled] = useState(false);

  const context = {
    name: name,
    phone: phone,
    alertCancelled: alertCancelled,
    setName: setName,
    setPhone: setPhone,
    setAlertCancelled: setAlertCancelled
  };

  return <UserContext.Provider value={context}>
    {props.children}
  </UserContext.Provider>
}

export default UserContext;